import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useCheckAuth from './hooks/useCheckAuth';

const PrivateRoutes = () => {
  const storedUser = localStorage.getItem('user');
  const user = storedUser ? JSON.parse(storedUser) : null;
  const checkAuth = useCheckAuth();

  useEffect(() => {
    checkAuth(true);
  }, []);

  if (user?.accessToken) {
    return <Outlet />;
  }

  return <Navigate to="/signIn" />;
};

export { PrivateRoutes };
